import { useEffect, useState } from 'react'
import { FormControlLabel, Checkbox, Stack, Box } from '@mui/material'
import { CALENDAR_OAUTH_TOKEN_PROVIDERS } from 'services/constants'
import { getThirdPartyOauth } from 'services/userServices'
import colors from 'styles/colors'
import RadioTags from 'components/atoms/RadioTags'
import LinkCalendarButton from 'components/molecules/oAuth/LinkCalendarButton'
import { useTranslation } from 'react-i18next'

const CalendarSetup = ({ formik }) => {
  const { t } = useTranslation()
  const [linked, setLinked] = useState(false)
  const [meetingProviderLabel, setMeetingProviderLabel] = useState(null)

  const checkCalenderLinked = async () => {
    const res = await getThirdPartyOauth()
    setLinked(res.validLinked)
    if (res?.data) {
      const { provider, meetingProvider } = res.data
      let providerLabel
      if (res.validLinked) {
        providerLabel =
          provider === CALENDAR_OAUTH_TOKEN_PROVIDERS.GOOGLE
            ? t('contact.googleMeet')
            : meetingProvider === 'teamsForBusiness'
              ? t('contact.microsoftTeams')
              : meetingProvider?.toLowerCase()?.includes('skype')
                ? t('contact.skype')
                : null
      }
      setMeetingProviderLabel(providerLabel)

      // Set true if provider is available
      formik.setFieldValue('videoConference', providerLabel ? true : false)
      formik.setFieldValue('recordMeeting', providerLabel ? true : false)
    }
  }

  const signinCallback = async success => {
    if (success) {
      checkCalenderLinked()
    }
  }

  useEffect(() => {
    checkCalenderLinked()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (formik.values.videoConference) {
      formik.setFieldValue('recordMeeting', true)
    } else {
      formik.setFieldValue('recordMeeting', false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.videoConference])

  const labelStyle = {
    color: colors.Grey400,
    width: 414,
    justifyContent: 'space-between'
  }

  return (
    <>
      {linked ? (
        <>
          {meetingProviderLabel && (
            <Stack padding={0} spacing={6}>
              <FormControlLabel
                label={t('contact.addVideoConferencing')}
                labelPlacement='start'
                sx={labelStyle}
                control={
                  <Checkbox
                    checked={formik.values.videoConference}
                    onChange={e =>
                      formik.setFieldValue('videoConference', e.target.checked)
                    }
                  />
                }
              />

              <RadioTags
                tags={[
                  {
                    key: 'meet',
                    value: 'meet',
                    label: meetingProviderLabel
                  }
                ]}
                selectedTag={formik.values.videoConference ? 'meet' : null}
                setSelectedTag={() => {}}
              />

              <FormControlLabel
                disabled={!formik.values.videoConference}
                label={t('contact.addNoteTaker')}
                labelPlacement='start'
                sx={labelStyle}
                control={
                  <Checkbox
                    checked={formik.values.recordMeeting}
                    onChange={e =>
                      formik.setFieldValue('recordMeeting', e.target.checked)
                    }
                  />
                }
              />
            </Stack>
          )}
        </>
      ) : (
        <Box padding={0} paddingY={12} spacing={6}>
          <LinkCalendarButton
            signinCallback={signinCallback}
            label={t('contact.connectYourCalendar')}
            btnProps={{ size: 'small', color: 'muted' }}
          />
        </Box>
      )}
    </>
  )
}

export default CalendarSetup
